import React, { useState } from "react";
import "./style.css";
import "../AddRelationshipForm/style.css"; // Reuse existing form styles for consistency
import { assignLicense } from "../../Services/subscription";
import { showErrorToast, showSuccessToast } from "../../Utils/toast";

export default function AssignMembershipModal({
  open = true,
  onClose,
  selectedLicence = [], // array of assignment_ids
  defaultEmail = "",
}) {
  const [form, setForm] = useState({ first_name: "", last_name: "", email: defaultEmail || "" });
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const onChange = (k) => (e) => setForm((p) => ({ ...p, [k]: e?.target ? e.target.value : e }));

  const isValidEmail = (v) => /[^@\s]+@[^@\s]+\.[^@\s]+/.test(String(v || "").trim());
  const requiredComplete =
    String(form.first_name || "").trim() &&
    String(form.last_name || "").trim() &&
    isValidEmail(form.email);

  const handleAssign = async () => {
    if (!requiredComplete) return;
    if (!Array.isArray(selectedLicence) || selectedLicence.length === 0) {
      showErrorToast("No license selected");
      return;
    }
    setSubmitting(true);
    try {
      for (const assignmentId of selectedLicence) {
        await assignLicense({
          license_id: assignmentId,
          email: String(form.email || "").toLowerCase(),
          first_name: form.first_name,
          last_name: form.last_name,
        });
      }
      showSuccessToast("Membership assigned successfully");
      onClose?.({ success: true });
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || "Failed to assign membership";
      showErrorToast(msg);
      // keep modal open for fix
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="assign-modal-overlay">
      <div className="assign-modal">
        <div className="assign-modal-header">
          <h2>Assign Membership</h2>
          <button className="assign-close-button" onClick={() => onClose?.({ success: false })}>×</button>
        </div>
        <div className="assign-modal-body">
          <div className="addrel-card">
            <div>
              <div className="grid-2">
                <div className="field">
                  <label>First Name</label>
                  <input value={form.first_name} onChange={onChange("first_name")} placeholder="First Name" />
                </div>
                <div className="field">
                  <label>Last Name</label>
                  <input value={form.last_name} onChange={onChange("last_name")} placeholder="Last Name" />
                </div>
              </div>
              <div className="field">
                <label>Email</label>
                <input type="email" value={form.email} onChange={onChange("email")} placeholder="Email" />
              </div>
            </div>
            <div className="actions">
              <button className="primary" onClick={handleAssign} disabled={!requiredComplete || submitting}>
                {submitting ? "Assigning..." : "Assign Membership"}
              </button>
              <button className="ghost" onClick={() => onClose?.({ success: false })} disabled={submitting}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
